import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from "react-router-dom";
import { LoginLayout } from "../layout/LoginLayout";
import App from "../pages/sharedPages/app/Index.js";
import AppPricing from "../pages/App/AppPricing.jsx";
import BusinessListening from "../pages/sharedPages/Business/index";
import BusinessReport from "../pages/Business/BusinessReport.jsx";
import ClosedTrades from "../pages/Business/ClosedTrades.jsx";
import CommunityDashboardForSocialLogin from "../pages/sharedPages/community/testBinanceLoginformember.js";
import CreatePassword from "../pages/auth/createPassword";
import CreateSubAccount from "../pages/sharedPages/CreateSubAccount.js";
import DeveloperScripts from "../pages/developerScriptRunPages.js";
import EmailGetter from "../pages/auth/emailGetter.js";
import ErrorPage from "../pages/errorPages/errorPage";
import ForgotPassword from "../pages/auth/forgotPassword";
import History from "../pages/Business/PayoutHistory.jsx";
import HowToGetPaid from "../pages/leader/LeaderGetPaid";
import LeaderCryptoPayment from "../pages/leader/LeaderCryptoPayment";
import LeaderExchange from "../pages/sharedPages/connect/LeaderExchange";
import LeaderSocialPlatforms from "../pages/leader/LeaderSocialPlatforms.js";
import LeaderSubscribers from "../pages/sharedPages/support/LeaderSubscribers";
import LeaderTrial from "../pages/leader/LeaderTrial";
import LiveTrade from "../pages/sharedPages/liveTrade/liveTrade.js";
import MemberExchange from "../pages/sharedPages/connect/MemberExchange";
import MemberListening from "../pages/sharedPages/Member";
import Members from "../pages/sharedPages/members/Index.js";
import NewCopyTrade from "../pages/sharedPages/NewCopyTrade";
import NewCopyTradeCM from "../pages/sharedPages/NewCopyTradeCM/index.jsx";
import NewLayout from "../layout/NewLayout.jsx";
import AdminLayout from "../layout/AdminLayout";
import CmNoLinkLatout from "../layout/CmNoLinkLatout";
import NewSetting from "../pages/sharedPages/newSetting";
import OrderApp from "../pages/App/OrderApp.jsx";
import Payment from "../pages/sharedPages/copyTradeCm/Payment.js";
import Performance from "../pages/sharedPages/performance/Index.js";
import PerformanceCm from "../pages/sharedPages/performanceCm/Index.js";
import Promote from "../pages/App/PromoteApp.jsx";
import React, { useState } from "react";
import ReferralCodes from "../pages/sharedPages/referralCodes/ReferralCodes";
import RiskManagement from "../pages/sharedPages/connect/RiskManagement";
import SignupCL from "../pages/auth/SignupCL/SignupCL.jsx";
import LoginAdmin from "../pages/auth/Admin/Admin";
import SignupMemberNoLink from "../pages/auth/SignUpMemberNoLink/SignupMemberNoLink.jsx";
import SubscriptionAndBilling from "../pages/SubscriptionAndBilling";
import SubscriptionPlans from "../pages/sharedPages/subscriptionPlans/SubscriptionPlans";
import Support from "../pages/sharedPages/support/Support";
import TradeHistory from "../pages/sharedPages/tradeHistory/TradeHistory";
import TradeSettings from "../pages/sharedPages/tradeSettings/TradeSettings";
import TradeSettingsCm from "../pages/sharedPages/tradeSettings/MemberTradeSettings.js";
import Trading from "../pages/sharedPages/performance/Trading.js";
import TradingListening from "../pages/sharedPages/Trading";
import CmNoLinkTrading from "../pages/sharedPages/Trading/CmNoLinkTrading.jsx";
import VerifyPayment from "../pages/sharedPages/VerifyPayment.js";
import VipScreen from "../pages/sharedPages/VipScreen/index.js";
import NewDashboard from "../pages/newDashBoard";
import ConnectExchange from "../pages/NewOnboarding/OnboardingCL/ConnectExchange/ConnectExchange.jsx";
import ConnectExchangeCM from "../pages/NewOnboarding/OnboardingCM/ConnectExchange/ConnectExchange.jsx";
import OnboardingCM from "../pages/NewOnboarding/OnboardingCM/index.jsx";
import CommunityName from "../pages/NewOnboarding/OnboardingCL/CommunityName/CommunityName.jsx";
import SelectSpotCoin from "../pages/NewOnboarding/OnboardingCL/SelectSpotCoin/SelectSpotCoin.jsx";
import GetPaid from "../pages/NewOnboarding/OnboardingCL/GetPaid/GetPaid.jsx";
import CreateSubscription from "../pages/NewOnboarding/OnboardingCL/CreateSubscription/CreateSubscription.jsx";
import Verify from "../pages/NewOnboarding/OnboardingCL/VerifyEmail/VerifyEmail.jsx";
import CompletedScreenCM from "../pages/NewOnboarding/OnboardingCM/CompletedScreenCM/CompletedScreenCM";
import CompletedScreenCMChangeCommunity from "../pages/NewOnboarding/OnboardingCM/CompletedScreenCM/CompletedScreenCMChangeCommunity";
import NewDesignVerifyEmail from "../pages/NewOnboarding/OnboardingCM/SignupCM/VerifyEmail";
import Done from "../pages/NewOnboarding/OnboardingCL/VerifyEmail/Done";
import ImportantUpdates from "../pages/NewOnboarding/OnboardingCL/ImportantUpdates/ImportantUpdates";
import SubmitEmail from "../pages/NewOnboarding/OnboardingCL/ImportantUpdates/SubmitEmail";
import SetupCompleted from "../pages/NewOnboarding/OnboardingCL/SetupCompleted/SetupCompleted";
import SetupScreen from "../pages/NewOnboarding/OnboardingCL/SetupScreen/SetupScreen";
import AllReview from "../pages/NewOnboarding/OnboardingCM/SubmitReview/AllReview.jsx";
import SubmitReview from "../pages/NewOnboarding/OnboardingCM/SubmitReview/SubmitReview";
import AdminDashBoard from "../pages/superadmin";
import MemberListining from "../pages/superadmin/MemberListining";
import ErrorLogsList from "../pages/superadmin/ErrorLogs/ErrorLogsList";
import ErrorLogDetail from "../pages/superadmin/ErrorLogs/ErrorLogDetail";
import MarketPlace from "../pages/sharedPages/MarketPlace";
import VerifyTradePayment from "../pages/VerifyTradePayment";
import VerifyTradeResult from "../pages/VerifyTradePayment/VerifyTradeResult";
import SubscriptionResult from "../pages/VerifyTradePayment/SubscriptionResult.jsx";
import VerifyTradeInfo from "../pages/VerifyTradePayment/VerifyTradeInfo";
import SubscriptionBillingHistory from "../pages/sharedPages/SubscriptionBillingHistory/index.jsx";
import VerifyMyTradeDashboard from "../pages/VerifyMyTrade/VerifyMyTradeDashboard";
import VerifiedTrading from "../pages/VerifyMyTrade/VerifiedTrading";
import VerifiedPaymentBillingHistory from "../pages/VerifyMyTrade/VerifiedPaymentBillingHistory";
import VerifyTradeSettings from "../pages/VerifyMyTrade/VerifyTradeSettings";
import VerifyTradeListing from "../pages/VerifyMyTrade/VerifyTradeListing";
import AddTradeName from "../pages/VerifyMyTrade/AddTradeName/index.jsx";
import PublicVerifiedTrade from "../pages/PublicVerifiedTrade";
import PublicLayout from "../layout/PublicLayout";
import VerifiedTradeView from "../pages/PublicVerifiedTrade/viewSearchVerifiedTrade/index.jsx";
import LeaderVerifedTrades from "../pages/VerifyMyTrade/LeaderVerifiedTrades/index.jsx";
import OnboardingCopyTradeService from "../pages/sharedPages/OnboardingCopyTradeService";
import PaymentSuccessModal from "../pages/sharedPages/PaymentSuccessModal/index.jsx";
import SubscribedInfoModal from "../pages/sharedPages/SubscribedInfoModal/index.jsx";
import TradesVerifiedInfoModal from "../pages/sharedPages/TradesVerifiedInfoModal/index.jsx";
import LoadingOverlay from "../pages/sharedPages/LoadingOverlay/index.jsx";
import StoringOnSolanaPlatform from "../pages/sharedPages/StoringOnSolanaPlatform/index.jsx";
import ExchangeInfo from "../pages/NewOnboarding/OnboardingCM/ConnectExchange/ExchangeInfoModal.jsx";
import SubscribeModal from "../pages/NewOnboarding/OnboardingCM/subscription/MemberSubscribe.jsx";
import ChangeCommunitySubscribeModal from "../pages/NewOnboarding/OnboardingCM/subscription/MemberSubscribeChangeCommunity.jsx";
import PublicSearchLayout from "../layout/PublicLayout/PublicSearchLayout.jsx";
import ExchangeOAuthCallback from "../components/auth/ExchangeOAuthCallback";
import { isOAuthReturnUrl } from "../helpers/exchangeOAuth";

export const MainRouting = () => {
  const [community, setCommunity] = useState(null);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/verifymytrades" element={<PublicSearchLayout />}>
          <Route index element={<PublicVerifiedTrade />} />
          <Route path=":id" element={<VerifiedTradeView />} />
        </Route>
        <Route path="/verifiedTrades" element={<PublicLayout />}>
          <Route path=":name" element={<LeaderVerifedTrades />}></Route>
        </Route>
        {/*login*/}
        <Route path="/login" element={<LoginLayout />}>
          <Route index element={<SignupCL />} />

          <Route path="createPassword/:id" element={<CreatePassword />}></Route>
          <Route path="forgotPassword" element={<ForgotPassword />}></Route>

          <Route
            path="newVerifyEmail"
            element={<NewDesignVerifyEmail />}
          ></Route>
        </Route>

        <Route path="/signin" element={<LoginLayout />}>
          <Route index element={<SignupCL />} />
        </Route>

        <Route path="/superadmin/login" element={<LoginLayout />}>
          <Route index element={<LoginAdmin />} />
        </Route>

        <Route
          path="/superadmin"
          element={<AdminLayout />}
          errorElement={<ErrorPage />}
         >
          <Route path="dashboard" element={<AdminDashBoard />}></Route>
          <Route
            path="community/:communityId"
            element={<MemberListining />}
          ></Route>
        </Route>

        <Route
          path="/authorizeSuperAdmin"
          element={<AdminLayout />}
          errorElement={<ErrorPage />}
        >
          <Route path="error-logs" element={<ErrorLogsList />} />
          <Route path="error-logs/:id" element={<ErrorLogDetail />} />
        </Route>

        <Route path="/cmWithNoLink/login" element={<LoginLayout />}>
          <Route index element={<SignupMemberNoLink />} />
        </Route>

        <Route
          path="/cmWithNoLink"
          element={<CmNoLinkLatout />}
          errorElement={<ErrorPage />}
        >
          <Route path="dashboard" element={<NewDashboard />}></Route>
          <Route path="marketPlace" element={<MarketPlace />}></Route>
          <Route path="copyTrade2" element={<NewCopyTradeCM />}></Route>
          <Route path="tradingListening" element={<CmNoLinkTrading />}></Route>
          <Route
            path="copyTrade"
            element={<SubscriptionAndBilling setCommunity={setCommunity} />}
          ></Route>
          <Route
            path="copyTrade/:id"
            element={<SubscriptionAndBilling setCommunity={setCommunity} />}
          ></Route>
        </Route>

        <Route
          path="/leader"
          element={<NewLayout />}
          errorElement={<ErrorPage />}
        >
          <Route path="app" element={<App />}></Route>
          <Route path="onBoardingNotComplete" element={<SetupScreen />}></Route>
          <Route path="connectExchange" element={<LeaderExchange />}></Route>
          <Route path="cryptoPayment" element={<LeaderCryptoPayment />}></Route>
          <Route path="dashboard" element={<VerifyMyTradeDashboard />} />
          <Route path="emailGetter" element={<EmailGetter />}></Route>
          <Route path="loadingOverlay" element={<LoadingOverlay />}></Route>
          <Route path="getPaid" element={<HowToGetPaid />}></Route>
          <Route path="getPaid/:id" element={<HowToGetPaid />}></Route>
          <Route path="liveTrade" element={<LiveTrade />}></Route>
          <Route path="memberListening" element={<MemberListening />}></Route>
          <Route path="members" element={<Members />}></Route>
          <Route path="newAccountSettings" element={<NewSetting />}></Route>
          <Route path="newCopyTrade" element={<NewCopyTrade />}></Route>
          <Route path="performance" element={<Performance />}></Route>
          <Route path="referralCodes" element={<ReferralCodes />}></Route>
          <Route path="social" element={<LeaderSocialPlatforms />}></Route>
          <Route path="subscribers" element={<LeaderSubscribers />}></Route>
          <Route
            path="subscriptionPlans"
            element={<SubscriptionPlans />}
          ></Route>
          <Route path="support" element={<Support />}></Route>
          <Route path="tradeHistory" element={<TradeHistory />}></Route>
          <Route path="tradeSettings" element={<TradeSettings />}></Route>
          <Route path="tradingListening" element={<TradingListening />}></Route>
          <Route path="trialPeriod" element={<LeaderTrial />}></Route>
          <Route path="vipMembers" element={<VipScreen />}></Route>

          <Route path="appPricing" element={<AppPricing />}></Route>
          <Route path="closedTrade" element={<ClosedTrades />}></Route>
          <Route path="orderApp" element={<OrderApp />}></Route>
          <Route path="overview" element={<Trading />}></Route>
          <Route path="payment" element={<BusinessListening />}></Route>
          {/* <Route path="newBusinessPage" element={<BusinessListening />}></Route> */}
          <Route path="payoutHistory" element={<History />}></Route>
          <Route path="promoteApp" element={<Promote />}></Route>
          <Route path="reports" element={<BusinessReport />}></Route>
          <Route path="addTradeName" element={<AddTradeName />} />
          <Route
            path="onboardingCopyTradeService"
            element={<OnboardingCopyTradeService />}
          />
          <Route path="paymentSuccessModal" element={<PaymentSuccessModal />} />
          <Route
            path="verifymyTrade/subscribedInfoModal"
            element={<SubscribedInfoModal />}
          />
          <Route
            path="verifymyTrade/tradesVerifiedInfoModal"
            element={<TradesVerifiedInfoModal />}
          />
          {/* <Route
            path="verifyMyTradeDashboard"
            element={<VerifyMyTradeDashboard />}
          /> */}
          <Route path="verifiedTrading" element={<VerifiedTrading />} />
          <Route
            path="verifiedPaymentBillingHistory"
            element={<VerifiedPaymentBillingHistory />}
          />
          <Route path="verifyTradeSettings" element={<VerifyTradeSettings />} />
          <Route path="verifyTradeListing" element={<VerifyTradeListing />} />
          <Route
            path="onboarding/community"
            element={<CommunityName />}
          ></Route>
          <Route
            path="onboarding/connection"
            element={<ConnectExchange />}
          ></Route>
          <Route
            path="onboarding/spotCoin"
            element={<SelectSpotCoin />}
          ></Route>
          <Route
            path="verifymyTrade/connection"
            element={<ConnectExchange />}
          ></Route>
          <Route
            path="verifymyTrade/tradeinfo"
            element={<VerifyTradeInfo />}
          ></Route>

          <Route
            path="verifymyTrade/payment"
            element={<VerifyTradePayment />}
          ></Route>

          <Route
            path="verifymyTrade/verifyTradeResult"
            element={<VerifyTradeResult />}
          ></Route>

          <Route
            path="verifymyTrade/subscriptionResult"
            element={<SubscriptionResult />}
          ></Route>

          <Route path="copyTrade/:id" element={<GetPaid />}></Route>
          <Route path="onboarding/payout" element={<GetPaid />}></Route>
          {/* onboarding/subscription */}
          <Route
            path="onboarding/subscription"
            element={<CreateSubscription />}
          ></Route>
          <Route path="onboarding/verify" element={<Verify />}></Route>
          <Route path="onboarding/alldone" element={<Done />}></Route>
          <Route
            path="onboarding/importantUpdates"
            element={<ImportantUpdates />}
          ></Route>

          <Route
            path="onboarding/submitNewEmail"
            element={<SubmitEmail />}
          ></Route>

          <Route
            path="onboarding/setupComplete"
            element={<SetupCompleted />}
          ></Route>

          <Route
            path="storingOnSolanaPlatform"
            element={<StoringOnSolanaPlatform />}
          />
        </Route>

        <Route
          path="/member"
          element={<NewLayout />}
          errorElement={<ErrorPage />}
        >
          <Route path="onboarding/view" element={<ExchangeInfo />}></Route>
          <Route path="subscribe/:id" element={<SubscribeModal />}></Route>
          <Route
            path="onboarding/subscription"
            element={<SubscribeModal />}
          ></Route>
          <Route
            path="changeCommunity/subscription"
            element={<ChangeCommunitySubscribeModal />}
          ></Route>
          <Route
            path="changeCommunity/subscribe/:id"
            element={<ChangeCommunitySubscribeModal />}
          ></Route>

          <Route path="closedTrade" element={<ClosedTrades />}></Route>
          <Route path="newAccountSettings" element={<NewSetting />}></Route>
          <Route path="connectExchange" element={<MemberExchange />}></Route>
          <Route
            path="copyTrade"
            element={<SubscriptionAndBilling setCommunity={setCommunity} />}
          ></Route>
          <Route
            path="copyTrade/:id"
            element={<SubscriptionAndBilling setCommunity={setCommunity} />}
          ></Route>
          <Route path="marketPlace" element={<MarketPlace />}></Route>
          <Route path="copyTrade2" element={<NewCopyTradeCM />}></Route>
          <Route path="createSubAccount" element={<CreateSubAccount />}></Route>
          <Route path="dashboard" element={<NewDashboard />}></Route>
          <Route path="emailGetter" element={<EmailGetter />}></Route>
          <Route path="liveTrade" element={<LiveTrade />}></Route>
          <Route path="performance" element={<PerformanceCm />}></Route>
          <Route
            path="subscriptionBillingHistory"
            element={<SubscriptionBillingHistory />}
          ></Route>
          <Route path="onBoardingNotComplete" element={<SetupScreen />}></Route>
          <Route path="tradingListening" element={<TradingListening />}></Route>
          <Route
            path="riskManagement/:exchange"
            element={<RiskManagement />}
          ></Route>
          <Route
            path="stripePaymentScreen"
            element={
              <Payment community={community} setCommunity={setCommunity} />
            }
          ></Route>
          <Route
            path="subscriptionPlans"
            element={<SubscriptionPlans />}
          ></Route>
          <Route
            path="subscriptionPlans/:id"
            element={<SubscriptionPlans />}
          ></Route>
          <Route path="support" element={<Support />}></Route>
          <Route path="tradeHistory" element={<TradeHistory />}></Route>
          <Route path="tradeSettings" element={<TradeSettingsCm />}></Route>

          <Route
            path="onboarding/connection"
            element={<ConnectExchangeCM />}
          ></Route>
          <Route path="onboarding/done" element={<CompletedScreenCM />}></Route>
          <Route
            path="changeCommunity/done"
            element={<CompletedScreenCMChangeCommunity />}
          ></Route>
          <Route path="submitReview" element={<SubmitReview />}></Route>
        </Route>
        <Route path="*" element={<Navigate to="/login" />} />
        <Route path="/community/:communityName" element={<OnboardingCM />} />
        <Route path="/community/reviews/:communityId" element={<AllReview />} />

        <Route
          path="/community/test/:communityName"
          element={<CommunityDashboardForSocialLogin />}
        />
        <Route path="/ninja256" element={<DeveloperScripts />} />
        <Route
          path="/new/community/:communityName"
          element={<OnboardingCM />}
        />
        {/* <Route path="/signup" element={<SignupLeader />} /> */}
        <Route path="/verifyPayment/:id" element={<VerifyPayment />} />
      </>,
    ),
  );
  return (
    <>
      {isOAuthReturnUrl() && <ExchangeOAuthCallback />}
      <RouterProvider router={router} />
    </>
  );
};
// nvm use 20.14.0
// nvm use 22.1.0
